import _ from "lodash";
import { createSelector } from "reselect";
import { parseUrl, stringify, ParseOptions } from "query-string";

import { Locale } from "@localisation/models";
import { getLocale } from "@localisation/selectors";
import { OldWataState as State } from "../models";
import { IframeProps } from "../components/Iframe";

const parseOptions: ParseOptions = { sort: false, arrayFormat: "bracket" };

export const getLastPath = (state: State) => state.oldwata.lastPath;
export const getLastUrl = (state: State) => state.oldwata.lastUrl;
export const getLastLoaded = (state: State) => state.oldwata.lastLoaded;
export const getAuthenticated = (state: State) => state.oldwata.authenticated;
export const getAuthenticatedAt = (state: State) => state.oldwata.authenticatedAt;
export const getLoggedOutAt = (state: State) => state.oldwata.loggedOutAt;
export const getIframeHeight = (state: State) =>
    state.oldwata.iframeHeight != null ? state.oldwata.iframeHeight + 20 : 800;
const getProps = (_state: State, props: IframeProps) => props;

export const getUrl = createSelector(
    getLastPath,
    getLastUrl,
    getLocale,
    getProps,
    (lastPath: string, url: string, locale: Locale, { path }: IframeProps) => {
        if (url != null && lastPath != null && path != null) {
            // Split the url that's pulled from the API to get the base and construct
            // a new url from the given path.
            const parsedUrl = parseUrl(url, parseOptions);
            const parsedPath = parseUrl(path, parseOptions);
            const parsedLastPath = parseUrl(lastPath, parseOptions);
            const baseUrl = url.split(parsedLastPath.url)[0];
            const query = {
                // Remove the query params in the lastPath
                ..._.omit(parsedUrl.query, _.keys(parsedLastPath.query)),
                ...parsedPath.query,
                lang: locale,
            };
            return baseUrl + parsedPath.url + "?" + stringify(query, parseOptions);
        }
        return null;
    },
);
